/* eslint-disable local-rules/prefer-use-query-params-callback */
import {useHistory, useQueryParams} from '@aboutyou/router';
import {useEffect, useRef} from 'react';
import {useNewsLetterSignUpStateManager} from '../../backend-services/NotificationCenter/useNewsLetterSignUpStateManager';
import {useWalletStateManager} from '../../backend-services/Wallet/utils/useWalletStateManager';
import {useAuthenticationPrompt} from '../Authentication/AuthenticationProvider/AuthenticationProvider';
import {AuthSearchParams} from '../Authentication/hooks/constants';
import {useIsAuthenticated} from '../Authentication/hooks/useIsAuthenticated';
import {useCoinsHistoryOpenedState} from '../Coins/CoinsHistory/hooks/useCoinsHistoryOpenedState';
import {useIsCoinsActive} from '../Coins/utils/useIsCoinsActive';

export enum DEEP_LINKS {
  cw = 'cw',
  newsletterSubscription = 'newsletterSubscription',
  coins = 'coins',
  coinsHistory = 'coinsHistory',
}

export const useDeepLinkOpener = () => {
  const queryParams = useQueryParams();
  const history = useHistory();
  const {isAuthenticated, isUserDataLoading} = useIsAuthenticated();
  const {showUserAuthenticationPrompt} = useAuthenticationPrompt();
  const {open: openWallet} = useWalletStateManager();
  const {open: openCoinsHistory} = useCoinsHistoryOpenedState();
  const isCoinsActive = useIsCoinsActive();
  const {open: openNewsletterSubscription} = useNewsLetterSignUpStateManager();
  const wasWalletOpen = useRef(false);

  // cw
  useEffect(() => {
    if (queryParams.get(DEEP_LINKS.cw) !== 'true') {
      return;
    }

    if (wasWalletOpen.current) {
      return;
    }

    if (
      queryParams.get(AuthSearchParams.LoginReason) !== 'coupon' ||
      isAuthenticated
    ) {
      openWallet('coupons');
      wasWalletOpen.current = true;
    }
  }, [queryParams]);

  // newsletterSubscription
  useEffect(() => {
    if (queryParams.get(DEEP_LINKS.newsletterSubscription)) {
      openNewsletterSubscription();
    }
  }, []);

  // coins
  useEffect(() => {
    if (isUserDataLoading) {
      return;
    }

    if (!queryParams.get(DEEP_LINKS.coins) || !isCoinsActive) {
      return;
    }

    if (!isAuthenticated) {
      showUserAuthenticationPrompt({
        context: 'coins-deeplink',
        needsCheckoutSession: false,
        onSuccess: () => {
          openWallet('coins');
        },
        onCancel: () => {
          history.push('/');
        },
      });
    } else {
      openWallet('coins');
    }
  }, [isUserDataLoading]);

  // coins history
  useEffect(() => {
    if (isUserDataLoading) {
      return;
    }

    if (!queryParams.get(DEEP_LINKS.coinsHistory) || !isCoinsActive) {
      return;
    }

    if (!isAuthenticated) {
      showUserAuthenticationPrompt({
        context: 'coins-deeplink',
        needsCheckoutSession: false,
        onSuccess: () => {
          openCoinsHistory();
        },
        onCancel: () => {
          history.push('/');
        },
      });
    } else {
      openCoinsHistory();
    }
  }, [isUserDataLoading]);
};
